/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import { mapGetters, mapState } from 'vuex'
import { ACCEPTED_GROUP, OPEN_MODAL, PWA_INSTALLABLE } from '../../../frontend/utils/events.js'
import BannerSimple from '../../../frontend/views/components/banners/BannerSimple.vue'
import ButtonSubmit from '../../../frontend/views/components/ButtonSubmit.vue'
import RenderMessageWithMarkdown from '../../../frontend/views/containers/chatroom/chat-mentions/RenderMessageWithMarkdown.js'
import SvgCreateGroup from '../../../frontend/assets/svgs/create-group.svg'
import SvgJoinGroup from '../../../frontend/assets/svgs/join-group.svg'
import { ignoreWhenNavigationCancelled } from '../../../frontend/views/utils/misc.js'

const __vue_script__ = ({
  name: 'Home',
  components: {
    SvgJoinGroup,
    SvgCreateGroup,
    BannerSimple,
    ButtonSubmit,
    RenderMessageWithMarkdown
  },
  computed: {
    ...mapGetters([
      'currentIdentityState',
      'seenWelcomeScreen'
    ]),
    ...mapState([
      'currentGroupId'
    ]),
    isLoggedIn () {
      return !!this.$store.state.loggedIn
    }
  },
  data () {
    return {
      ephemeral: {
        serverMessages: [],
        seenWelcomeScreen: false,
        listener: ({ contractID }) => {
          if (contractID !== this.currentGroupId) return
          // For first time joins, force redirect to /pending-approval
          this.ephemeral.seenWelcomeScreen = false
        },
        showPwaPromo: false
      }
    }
  },
  beforeMount () {
    sbp('okTurtles.events/on', ACCEPTED_GROUP, this.ephemeral.listener)
    this.checkPwaInstallability()
    fetch(`${sbp('okTurtles.data/get', 'API_URL')}/serverMessages`).then(async (r) => {
      const data = await r.json()
      this.ephemeral.serverMessages = data.filter((msg) => msg.type === 'giHomeWarning').map((msg) => msg.message)
    }).catch(e => {
      console.error('[Home.vue] Error fetching or processing server announcements', e)
    })
  },
  mounted () {
    this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen
    if (this.isLoggedIn && this.currentGroupId) {
      this.navigateToGroupPage()
    } else if (this.$route.query.next) {
      this.openModal('LoginModal')
    }
  },
  destroyed () {
    sbp('okTurtles.events/off', ACCEPTED_GROUP, this.ephemeral.listener)
  },
  methods: {
    openModal (mode) {
      sbp('okTurtles.events/emit', OPEN_MODAL, mode)
    },
    navigateToGroupPage () {
      // NOTE:
      // When browser refresh is triggered, there is an issue that Vue router prematurely decides ('loginGuard' there) that
      // the user is not signed in when in actual reality user-login is still being processed and then
      // takes user to 'Home.vue' with the '$route.query.next' being set to the initial url.
      // In this particular condition, the app needs to immediately redirect user to '$route.query.next'
      // so that the user stays in the same page after the browser refresh.
      // (Related GH issue: https://github.com/okTurtles/group-income/issues/1830)
      const path = this.$route.query.next ?? (this.ephemeral.seenWelcomeScreen ? '/dashboard' : '/pending-approval')
      this.$router.push({ path }).catch(e => ignoreWhenNavigationCancelled(e, path))
    },
    checkPwaInstallability () {
      this.ephemeral.showPwaPromo = sbp('service-worker/check-pwa-installability')
      sbp('okTurtles.events/once', PWA_INSTALLABLE, () => {
        this.ephemeral.showPwaPromo = true
      })
    },
    async onInstallClick () {
      await sbp('service-worker/trigger-install-prompt')
    }
  },
  watch: {
    currentGroupId (to) {
      // Redirect to `/pending-approval` if our profile isn't active or the
      // welcome screen hasn't been approved
      this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen
      if (to && this.isLoggedIn) {
        this.navigateToGroupPage()
      }
    },
    isLoggedIn (to) {
      if (to && this.currentGroupId) {
        this.navigateToGroupPage()
      }
    }
  }
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.currentGroupId
    ? _c(
        "main",
        { staticClass: "c-splash", attrs: { "data-test": "homeLogo" } },
        [
          !_vm.isLoggedIn
            ? _c(
                "header",
                { key: "title-login" },
                [
                  _c("img", {
                    staticClass: "logo",
                    attrs: {
                      src: "/assets/images/group-income-icon-transparent.png",
                    },
                  }),
                  _c(
                    "i18n",
                    {
                      staticClass: "is-title-1",
                      attrs: { tag: "h1", "data-test": "welcomeHome" },
                    },
                    [_vm._v("Welcome to Group Income")]
                  ),
                ],
                1
              )
            : _c(
                "header",
                { key: "title-not-login" },
                [
                  _c("img", {
                    staticClass: "logo-2",
                    attrs: { src: "/assets/images/logo-transparent.png" },
                  }),
                  _c(
                    "i18n",
                    { staticClass: "is-subtitle", attrs: { tag: "p" } },
                    [_vm._v("Welcome to Group Income")]
                  ),
                  _c(
                    "i18n",
                    {
                      staticClass: "is-title-1",
                      attrs: { tag: "h1", "data-test": "welcomeHomeLoggedIn" },
                    },
                    [_vm._v("Let’s get this party started")]
                  ),
                ],
                1
              ),
          !_vm.isLoggedIn
            ? _c(
                "div",
                { key: "body-loggin", staticClass: "buttons" },
                [
                  _c(
                    "i18n",
                    {
                      ref: "loginBtn",
                      attrs: { tag: "button", "data-test": "loginBtn" },
                      on: {
                        click: function ($event) {
                          return _vm.openModal("LoginModal")
                        },
                      },
                    },
                    [_vm._v("Login")]
                  ),
                  _c(
                    "i18n",
                    {
                      directives: [{ name: "focus", rawName: "v-focus" }],
                      ref: "signupBtn",
                      attrs: { tag: "button", "data-test": "signupBtn" },
                      on: {
                        click: function ($event) {
                          return _vm.openModal("SignupModal")
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.openModal("SignupModal")
                        },
                      },
                    },
                    [_vm._v("Signup")]
                  ),
                ],
                1
              )
            : _c("div", { key: "body-create", staticClass: "create-or-join" }, [
                _c(
                  "div",
                  { staticClass: "card" },
                  [
                    _c("svg-create-group"),
                    _c(
                      "i18n",
                      { staticClass: "is-title-3", attrs: { tag: "h3" } },
                      [_vm._v("Create")]
                    ),
                    _c("i18n", { attrs: { tag: "p" } }, [
                      _vm._v("Create a new group and invite your friends."),
                    ]),
                    _c(
                      "i18n",
                      {
                        attrs: {
                          tag: "button",
                          "data-test": "createGroup",
                          "aria-label": _vm.L("Add a group"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openModal("GroupCreationModal")
                          },
                        },
                      },
                      [_vm._v("Create Group")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "card" },
                  [
                    _c("svg-join-group"),
                    _c(
                      "i18n",
                      { staticClass: "is-title-3", attrs: { tag: "h3" } },
                      [_vm._v("Join")]
                    ),
                    _c("i18n", { attrs: { tag: "p" } }, [
                      _vm._v("Enter an existing group using your username."),
                    ]),
                    _c(
                      "i18n",
                      {
                        attrs: { tag: "button", "data-test": "joinGroup" },
                        on: {
                          click: function ($event) {
                            return _vm.openModal("GroupJoinModal")
                          },
                        },
                      },
                      [_vm._v("Join a Group")]
                    ),
                  ],
                  1
                ),
              ]),
          !_vm.isLoggedIn && _vm.ephemeral.showPwaPromo
            ? _c(
                "banner-simple",
                {
                  staticClass: "hide-hoverable-device hide-tablet c-pwa-promo",
                  attrs: { severity: "general" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("i18n", [
                              _vm._v(
                                "Install this web app on your device for better usability."
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1382767684
                  ),
                },
                [
                  _c(
                    "button-submit",
                    {
                      staticClass: "is-success is-small c-install-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.onInstallClick },
                    },
                    [_vm._v(_vm._s(_vm.L("Install")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isLoggedIn && _vm.ephemeral.serverMessages.length > 0
            ? _c(
                "footer",
                { staticClass: "c-footer" },
                _vm._l(_vm.ephemeral.serverMessages, function (text) {
                  return _c(
                    "banner-simple",
                    {
                      staticClass: "c-demo-warning",
                      attrs: { severity: "warning" },
                    },
                    [
                      _c("render-message-with-markdown", {
                        attrs: { text: text },
                      }),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-eb568d1c_0", { source: ".c-splash[data-v-eb568d1c] {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  min-height: 100%;\n}\n@media screen and (min-width: 769px), print {\n.c-splash[data-v-eb568d1c] {\n    justify-content: center;\n}\n}\n.logo[data-v-eb568d1c] {\n  width: 8rem;\n  margin: 2rem auto;\n}\n.logo-2[data-v-eb568d1c] {\n  width: 8rem;\n  margin: 0 auto 3rem auto;\n}\n@media screen and (min-width: 769px), print {\n.logo-2[data-v-eb568d1c] {\n    margin: 0;\n    position: absolute;\n    left: 1.5rem;\n    top: 1.5rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-subtitle[data-v-eb568d1c] {\n    margin-top: 3rem;\n}\n}\n@media screen and (min-width: 1200px) {\n.is-subtitle[data-v-eb568d1c] {\n    margin-top: 0;\n}\n}\n.buttons[data-v-eb568d1c] {\n  min-width: 230px;\n}\n.create-or-join[data-v-eb568d1c] {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n  justify-content: center;\n  text-align: left;\n}\n@media screen and (min-width: 769px), print {\n.create-or-join[data-v-eb568d1c] {\n    text-align: center;\n}\n}\n.card[data-v-eb568d1c] {\n  margin: 1.5rem 1.5rem 0 1.5rem;\n  width: 100%;\n}\n@media screen and (min-width: 769px), print {\n.card[data-v-eb568d1c] {\n    width: 24.375rem;\n}\n}\n.card h3[data-v-eb568d1c] {\n  margin-bottom: 0.25rem;\n}\n.card svg[data-v-eb568d1c] {\n  width: 6rem;\n  margin-left: 1rem;\n  float: right;\n}\n@media screen and (min-width: 769px), print {\n.card svg[data-v-eb568d1c] {\n    float: none;\n    width: 9.75rem;\n    margin: 2.5rem auto 1.5rem auto;\n}\n}\n.card .button[data-v-eb568d1c] {\n  margin-top: 2rem;\n}\n@media screen and (min-width: 769px), print {\n.card .button[data-v-eb568d1c] {\n    margin-bottom: 1rem;\n}\n}\n.c-footer[data-v-eb568d1c] {\n  margin-top: 2.25rem;\n  padding: 0 1rem;\n  max-width: 31.25rem;\n}\n.c-demo-warning[data-v-eb568d1c] {\n  text-align: start;\n  margin-block-end: 1rem;\n}\n.c-pwa-promo[data-v-eb568d1c] {\n  position: fixed;\n  bottom: 1.875rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  text-align: left;\n  width: calc(100vw - 3rem);\n  max-width: 31.25rem;\n}\n.c-pwa-promo[data-v-eb568d1c]  .c-body {\n  margin-top: 1rem;\n  text-align: right;\n}\n.c-install-btn[data-v-eb568d1c] {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n\n/*# sourceMappingURL=Home.vue.map */", map: {"version":3,"sources":["frontend/views/pages/Home.vue","Home.vue"],"names":[],"mappings":"AAuLA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ACtLA;AACA;ADgLA;IAQA,uBAAA;ACrLE;AACF;ADwLA;EACA,WAAA;EACA,iBAAA;ACrLA;ADwLA;EACA,WAAA;EACA,wBAAA;ACrLA;AACA;ADkLA;IAKA,SAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;ACpLE;AACF;AAEA;ADqLA;IAEA,gBAAA;ACpLE;AACF;AACA;ADgLA;IAMA,aAAA;ACnLE;AACF;ADsLA;EACA,gBAAA;ACnLA;ADsLA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;ACnLA;AACA;AD4KA;IAQA,kBAAA;ACjLE;AACF;ADoLA;EACA,8BAAA;EACA,WAAA;ACjLA;AACA;AD8KA;IAKA,gBAAA;AChLE;AACF;ADkLA;EACA,sBAAA;AChLA;ADmLA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;ACjLA;AACA;AD6KA;IAKA,WAAA;IACA,cAAA;IACA,+BAAA;AC/KE;AACF;ADkLA;EACA,gBAAA;AChLA;AACA;AD8KA;IAIA,mBAAA;AC/KE;AACF;ADmLA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AChLA;ADmLA;EACA,iBAAA;EACA,sBAAA;AChLA;ADmLA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AChLA;ADkLA;EACA,gBAAA;EACA,iBAAA;AChLA;ADoLA;EACA,qBAAA;EACA,sBAAA;ACjLA;;AAEA,mCAAmC","file":"Home.vue","sourcesContent":["<template lang='pug'>\nmain.c-splash(data-test='homeLogo' v-if='!currentGroupId')\n  //- TODO: split this into two files, one showing the login/signup buttons\n  //-       and the other showing the create/join group buttons!\n  header(v-if='!isLoggedIn' key='title-login')\n    img.logo(src='/assets/images/group-income-icon-transparent.png')\n    i18n.is-title-1(tag='h1' data-test='welcomeHome') Welcome to Group Income\n\n  header(v-else key='title-not-login')\n    img.logo-2(src='/assets/images/logo-transparent.png')\n    i18n.is-subtitle(tag='p') Welcome to Group Income\n    i18n.is-title-1(tag='h1' data-test='welcomeHomeLoggedIn') Let’s get this party started\n\n  .buttons(v-if='!isLoggedIn' key='body-loggin')\n    i18n(\n      tag='button'\n      ref='loginBtn'\n      @click='openModal(\"LoginModal\")'\n      data-test='loginBtn'\n    ) Login\n\n    i18n(\n      tag='button'\n      ref='signupBtn'\n      @click='openModal(\"SignupModal\")'\n      @keyup.enter='openModal(\"SignupModal\")'\n      data-test='signupBtn'\n      v-focus=''\n    ) Signup\n\n  .create-or-join(v-else key='body-create')\n    .card\n      svg-create-group\n      i18n.is-title-3(tag='h3') Create\n      i18n(tag='p') Create a new group and invite your friends.\n\n      i18n(\n        tag='button'\n        @click='openModal(\"GroupCreationModal\")'\n        data-test='createGroup'\n        :aria-label='L(\"Add a group\")'\n      ) Create Group\n\n    .card\n      svg-join-group\n      i18n.is-title-3(tag='h3') Join\n      i18n(tag='p') Enter an existing group using your username.\n      i18n(\n        tag='button'\n        @click='openModal(\"GroupJoinModal\")'\n        data-test='joinGroup'\n      ) Join a Group\n\n  banner-simple.hide-hoverable-device.hide-tablet.c-pwa-promo(\n    v-if='!isLoggedIn && ephemeral.showPwaPromo'\n    severity='general'\n  )\n    template(#header='')\n      i18n Install this web app on your device for better usability.\n\n    button-submit.is-success.is-small.c-install-btn(\n      type='button'\n      @click='onInstallClick'\n    ) {{ L('Install') }}\n\n  footer.c-footer(v-if='!isLoggedIn && ephemeral.serverMessages.length > 0')\n    banner-simple.c-demo-warning(v-for='text in ephemeral.serverMessages' severity='warning')\n      render-message-with-markdown(:text='text')\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport { mapGetters, mapState } from 'vuex'\nimport { ACCEPTED_GROUP, OPEN_MODAL, PWA_INSTALLABLE } from '../../../frontend/utils/events.js'\nimport BannerSimple from '../../../frontend/views/components/banners/BannerSimple.vue'\nimport ButtonSubmit from '../../../frontend/views/components/ButtonSubmit.vue'\nimport RenderMessageWithMarkdown from '../../../frontend/views/containers/chatroom/chat-mentions/RenderMessageWithMarkdown.js'\nimport SvgCreateGroup from '../../../frontend/assets/svgs/create-group.svg'\nimport SvgJoinGroup from '../../../frontend/assets/svgs/join-group.svg'\nimport { ignoreWhenNavigationCancelled } from '../../../frontend/views/utils/misc.js'\n\nexport default ({\n  name: 'Home',\n  components: {\n    SvgJoinGroup,\n    SvgCreateGroup,\n    BannerSimple,\n    ButtonSubmit,\n    RenderMessageWithMarkdown\n  },\n  computed: {\n    ...mapGetters([\n      'currentIdentityState',\n      'seenWelcomeScreen'\n    ]),\n    ...mapState([\n      'currentGroupId'\n    ]),\n    isLoggedIn () {\n      return !!this.$store.state.loggedIn\n    }\n  },\n  data () {\n    return {\n      ephemeral: {\n        serverMessages: [],\n        seenWelcomeScreen: false,\n        listener: ({ contractID }) => {\n          if (contractID !== this.currentGroupId) return\n          // For first time joins, force redirect to /pending-approval\n          this.ephemeral.seenWelcomeScreen = false\n        },\n        showPwaPromo: false\n      }\n    }\n  },\n  beforeMount () {\n    sbp('okTurtles.events/on', ACCEPTED_GROUP, this.ephemeral.listener)\n    this.checkPwaInstallability()\n    fetch(`${sbp('okTurtles.data/get', 'API_URL')}/serverMessages`).then(async (r) => {\n      const data = await r.json()\n      this.ephemeral.serverMessages = data.filter((msg) => msg.type === 'giHomeWarning').map((msg) => msg.message)\n    }).catch(e => {\n      console.error('[Home.vue] Error fetching or processing server announcements', e)\n    })\n  },\n  mounted () {\n    this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen\n    if (this.isLoggedIn && this.currentGroupId) {\n      this.navigateToGroupPage()\n    } else if (this.$route.query.next) {\n      this.openModal('LoginModal')\n    }\n  },\n  destroyed () {\n    sbp('okTurtles.events/off', ACCEPTED_GROUP, this.ephemeral.listener)\n  },\n  methods: {\n    openModal (mode) {\n      sbp('okTurtles.events/emit', OPEN_MODAL, mode)\n    },\n    navigateToGroupPage () {\n      // NOTE:\n      // When browser refresh is triggered, there is an issue that Vue router prematurely decides ('loginGuard' there) that\n      // the user is not signed in when in actual reality user-login is still being processed and then\n      // takes user to 'Home.vue' with the '$route.query.next' being set to the initial url.\n      // In this particular condition, the app needs to immediately redirect user to '$route.query.next'\n      // so that the user stays in the same page after the browser refresh.\n      // (Related GH issue: https://github.com/okTurtles/group-income/issues/1830)\n      const path = this.$route.query.next ?? (this.ephemeral.seenWelcomeScreen ? '/dashboard' : '/pending-approval')\n      this.$router.push({ path }).catch(e => ignoreWhenNavigationCancelled(e, path))\n    },\n    checkPwaInstallability () {\n      this.ephemeral.showPwaPromo = sbp('service-worker/check-pwa-installability')\n      sbp('okTurtles.events/once', PWA_INSTALLABLE, () => {\n        this.ephemeral.showPwaPromo = true\n      })\n    },\n    async onInstallClick () {\n      await sbp('service-worker/trigger-install-prompt')\n    }\n  },\n  watch: {\n    currentGroupId (to) {\n      // Redirect to `/pending-approval` if our profile isn't active or the\n      // welcome screen hasn't been approved\n      this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen\n      if (to && this.isLoggedIn) {\n        this.navigateToGroupPage()\n      }\n    },\n    isLoggedIn (to) {\n      if (to && this.currentGroupId) {\n        this.navigateToGroupPage()\n      }\n    }\n  }\n}: Object)\n</script>\n\n<style scoped lang=\"scss\">\n@import \"../../../frontend/assets/style/_variables.scss\";\n\n.c-splash {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  min-height: 100%;\n\n  @include tablet {\n    justify-content: center;\n  }\n}\n\n.logo {\n  width: 8rem;\n  margin: 2rem auto;\n}\n\n.logo-2 {\n  width: 8rem;\n  margin: 0 auto 3rem auto;\n\n  @include tablet {\n    margin: 0;\n    position: absolute;\n    left: 1.5rem;\n    top: 1.5rem;\n  }\n}\n\n.is-subtitle {\n  @include tablet {\n    margin-top: 3rem;\n  }\n\n  @include desktop {\n    margin-top: 0;\n  }\n}\n\n.buttons {\n  min-width: 230px;\n}\n\n.create-or-join {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n  justify-content: center;\n  text-align: left;\n  @include tablet {\n    text-align: center;\n  }\n}\n\n.card {\n  margin: 1.5rem 1.5rem 0 1.5rem;\n  width: 100%;\n\n  @include tablet {\n    width: 24.375rem;\n  }\n\n  h3 {\n    margin-bottom: 0.25rem;\n  }\n\n  svg {\n    width: 6rem;\n    margin-left: 1rem;\n    float: right;\n    @include tablet {\n      float: none;\n      width: 9.75rem;\n      margin: 2.5rem auto 1.5rem auto;\n    }\n  }\n\n  .button {\n    margin-top: 2rem;\n\n    @include tablet {\n      margin-bottom: 1rem;\n    }\n  }\n}\n\n.c-footer {\n  margin-top: 2.25rem;\n  padding: 0 1rem;\n  max-width: 31.25rem;\n}\n\n.c-demo-warning {\n  text-align: start;\n  margin-block-end: 1rem;\n}\n\n.c-pwa-promo {\n  position: fixed;\n  bottom: 1.875rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10; // should be less than modal, tooltip, prompt etc.\n  text-align: left;\n  width: calc(100vw - 3rem);\n  max-width: 31.25rem;\n\n  ::v-deep .c-body {\n    margin-top: 1rem;\n    text-align: right;\n  }\n}\n\n.c-install-btn {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n</style>\n",".c-splash {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  min-height: 100%;\n}\n@media screen and (min-width: 769px), print {\n  .c-splash {\n    justify-content: center;\n  }\n}\n\n.logo {\n  width: 8rem;\n  margin: 2rem auto;\n}\n\n.logo-2 {\n  width: 8rem;\n  margin: 0 auto 3rem auto;\n}\n@media screen and (min-width: 769px), print {\n  .logo-2 {\n    margin: 0;\n    position: absolute;\n    left: 1.5rem;\n    top: 1.5rem;\n  }\n}\n\n@media screen and (min-width: 769px), print {\n  .is-subtitle {\n    margin-top: 3rem;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .is-subtitle {\n    margin-top: 0;\n  }\n}\n\n.buttons {\n  min-width: 230px;\n}\n\n.create-or-join {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n  justify-content: center;\n  text-align: left;\n}\n@media screen and (min-width: 769px), print {\n  .create-or-join {\n    text-align: center;\n  }\n}\n\n.card {\n  margin: 1.5rem 1.5rem 0 1.5rem;\n  width: 100%;\n}\n@media screen and (min-width: 769px), print {\n  .card {\n    width: 24.375rem;\n  }\n}\n.card h3 {\n  margin-bottom: 0.25rem;\n}\n.card svg {\n  width: 6rem;\n  margin-left: 1rem;\n  float: right;\n}\n@media screen and (min-width: 769px), print {\n  .card svg {\n    float: none;\n    width: 9.75rem;\n    margin: 2.5rem auto 1.5rem auto;\n  }\n}\n.card .button {\n  margin-top: 2rem;\n}\n@media screen and (min-width: 769px), print {\n  .card .button {\n    margin-bottom: 1rem;\n  }\n}\n\n.c-footer {\n  margin-top: 2.25rem;\n  padding: 0 1rem;\n  max-width: 31.25rem;\n}\n\n.c-demo-warning {\n  text-align: start;\n  margin-block-end: 1rem;\n}\n\n.c-pwa-promo {\n  position: fixed;\n  bottom: 1.875rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  text-align: left;\n  width: calc(100vw - 3rem);\n  max-width: 31.25rem;\n}\n.c-pwa-promo ::v-deep .c-body {\n  margin-top: 1rem;\n  text-align: right;\n}\n\n.c-install-btn {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n\n/*# sourceMappingURL=Home.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-eb568d1c"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\nmain.c-splash(data-test='homeLogo' v-if='!currentGroupId')\n  //- TODO: split this into two files, one showing the login/signup buttons\n  //-       and the other showing the create/join group buttons!\n  header(v-if='!isLoggedIn' key='title-login')\n    img.logo(src='/assets/images/group-income-icon-transparent.png')\n    i18n.is-title-1(tag='h1' data-test='welcomeHome') Welcome to Group Income\n\n  header(v-else key='title-not-login')\n    img.logo-2(src='/assets/images/logo-transparent.png')\n    i18n.is-subtitle(tag='p') Welcome to Group Income\n    i18n.is-title-1(tag='h1' data-test='welcomeHomeLoggedIn') Let’s get this party started\n\n  .buttons(v-if='!isLoggedIn' key='body-loggin')\n    i18n(\n      tag='button'\n      ref='loginBtn'\n      @click='openModal(\"LoginModal\")'\n      data-test='loginBtn'\n    ) Login\n\n    i18n(\n      tag='button'\n      ref='signupBtn'\n      @click='openModal(\"SignupModal\")'\n      @keyup.enter='openModal(\"SignupModal\")'\n      data-test='signupBtn'\n      v-focus=''\n    ) Signup\n\n  .create-or-join(v-else key='body-create')\n    .card\n      svg-create-group\n      i18n.is-title-3(tag='h3') Create\n      i18n(tag='p') Create a new group and invite your friends.\n\n      i18n(\n        tag='button'\n        @click='openModal(\"GroupCreationModal\")'\n        data-test='createGroup'\n        :aria-label='L(\"Add a group\")'\n      ) Create Group\n\n    .card\n      svg-join-group\n      i18n.is-title-3(tag='h3') Join\n      i18n(tag='p') Enter an existing group using your username.\n      i18n(\n        tag='button'\n        @click='openModal(\"GroupJoinModal\")'\n        data-test='joinGroup'\n      ) Join a Group\n\n  banner-simple.hide-hoverable-device.hide-tablet.c-pwa-promo(\n    v-if='!isLoggedIn && ephemeral.showPwaPromo'\n    severity='general'\n  )\n    template(#header='')\n      i18n Install this web app on your device for better usability.\n\n    button-submit.is-success.is-small.c-install-btn(\n      type='button'\n      @click='onInstallClick'\n    ) {{ L('Install') }}\n\n  footer.c-footer(v-if='!isLoggedIn && ephemeral.serverMessages.length > 0')\n    banner-simple.c-demo-warning(v-for='text in ephemeral.serverMessages' severity='warning')\n      render-message-with-markdown(:text='text')\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport { mapGetters, mapState } from 'vuex'\nimport { ACCEPTED_GROUP, OPEN_MODAL, PWA_INSTALLABLE } from '../../../frontend/utils/events.js'\nimport BannerSimple from '../../../frontend/views/components/banners/BannerSimple.vue'\nimport ButtonSubmit from '../../../frontend/views/components/ButtonSubmit.vue'\nimport RenderMessageWithMarkdown from '../../../frontend/views/containers/chatroom/chat-mentions/RenderMessageWithMarkdown.js'\nimport SvgCreateGroup from '../../../frontend/assets/svgs/create-group.svg'\nimport SvgJoinGroup from '../../../frontend/assets/svgs/join-group.svg'\nimport { ignoreWhenNavigationCancelled } from '../../../frontend/views/utils/misc.js'\n\nexport default ({\n  name: 'Home',\n  components: {\n    SvgJoinGroup,\n    SvgCreateGroup,\n    BannerSimple,\n    ButtonSubmit,\n    RenderMessageWithMarkdown\n  },\n  computed: {\n    ...mapGetters([\n      'currentIdentityState',\n      'seenWelcomeScreen'\n    ]),\n    ...mapState([\n      'currentGroupId'\n    ]),\n    isLoggedIn () {\n      return !!this.$store.state.loggedIn\n    }\n  },\n  data () {\n    return {\n      ephemeral: {\n        serverMessages: [],\n        seenWelcomeScreen: false,\n        listener: ({ contractID }) => {\n          if (contractID !== this.currentGroupId) return\n          // For first time joins, force redirect to /pending-approval\n          this.ephemeral.seenWelcomeScreen = false\n        },\n        showPwaPromo: false\n      }\n    }\n  },\n  beforeMount () {\n    sbp('okTurtles.events/on', ACCEPTED_GROUP, this.ephemeral.listener)\n    this.checkPwaInstallability()\n    fetch(`${sbp('okTurtles.data/get', 'API_URL')}/serverMessages`).then(async (r) => {\n      const data = await r.json()\n      this.ephemeral.serverMessages = data.filter((msg) => msg.type === 'giHomeWarning').map((msg) => msg.message)\n    }).catch(e => {\n      console.error('[Home.vue] Error fetching or processing server announcements', e)\n    })\n  },\n  mounted () {\n    this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen\n    if (this.isLoggedIn && this.currentGroupId) {\n      this.navigateToGroupPage()\n    } else if (this.$route.query.next) {\n      this.openModal('LoginModal')\n    }\n  },\n  destroyed () {\n    sbp('okTurtles.events/off', ACCEPTED_GROUP, this.ephemeral.listener)\n  },\n  methods: {\n    openModal (mode) {\n      sbp('okTurtles.events/emit', OPEN_MODAL, mode)\n    },\n    navigateToGroupPage () {\n      // NOTE:\n      // When browser refresh is triggered, there is an issue that Vue router prematurely decides ('loginGuard' there) that\n      // the user is not signed in when in actual reality user-login is still being processed and then\n      // takes user to 'Home.vue' with the '$route.query.next' being set to the initial url.\n      // In this particular condition, the app needs to immediately redirect user to '$route.query.next'\n      // so that the user stays in the same page after the browser refresh.\n      // (Related GH issue: https://github.com/okTurtles/group-income/issues/1830)\n      const path = this.$route.query.next ?? (this.ephemeral.seenWelcomeScreen ? '/dashboard' : '/pending-approval')\n      this.$router.push({ path }).catch(e => ignoreWhenNavigationCancelled(e, path))\n    },\n    checkPwaInstallability () {\n      this.ephemeral.showPwaPromo = sbp('service-worker/check-pwa-installability')\n      sbp('okTurtles.events/once', PWA_INSTALLABLE, () => {\n        this.ephemeral.showPwaPromo = true\n      })\n    },\n    async onInstallClick () {\n      await sbp('service-worker/trigger-install-prompt')\n    }\n  },\n  watch: {\n    currentGroupId (to) {\n      // Redirect to `/pending-approval` if our profile isn't active or the\n      // welcome screen hasn't been approved\n      this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen\n      if (to && this.isLoggedIn) {\n        this.navigateToGroupPage()\n      }\n    },\n    isLoggedIn (to) {\n      if (to && this.currentGroupId) {\n        this.navigateToGroupPage()\n      }\n    }\n  }\n}: Object)\n</script>\n\n<style scoped lang=\"scss\">\n@import \"../../../frontend/assets/style/_variables.scss\";\n\n.c-splash {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  align-items: center;\n  min-height: 100%;\n\n  @include tablet {\n    justify-content: center;\n  }\n}\n\n.logo {\n  width: 8rem;\n  margin: 2rem auto;\n}\n\n.logo-2 {\n  width: 8rem;\n  margin: 0 auto 3rem auto;\n\n  @include tablet {\n    margin: 0;\n    position: absolute;\n    left: 1.5rem;\n    top: 1.5rem;\n  }\n}\n\n.is-subtitle {\n  @include tablet {\n    margin-top: 3rem;\n  }\n\n  @include desktop {\n    margin-top: 0;\n  }\n}\n\n.buttons {\n  min-width: 230px;\n}\n\n.create-or-join {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n  justify-content: center;\n  text-align: left;\n  @include tablet {\n    text-align: center;\n  }\n}\n\n.card {\n  margin: 1.5rem 1.5rem 0 1.5rem;\n  width: 100%;\n\n  @include tablet {\n    width: 24.375rem;\n  }\n\n  h3 {\n    margin-bottom: 0.25rem;\n  }\n\n  svg {\n    width: 6rem;\n    margin-left: 1rem;\n    float: right;\n    @include tablet {\n      float: none;\n      width: 9.75rem;\n      margin: 2.5rem auto 1.5rem auto;\n    }\n  }\n\n  .button {\n    margin-top: 2rem;\n\n    @include tablet {\n      margin-bottom: 1rem;\n    }\n  }\n}\n\n.c-footer {\n  margin-top: 2.25rem;\n  padding: 0 1rem;\n  max-width: 31.25rem;\n}\n\n.c-demo-warning {\n  text-align: start;\n  margin-block-end: 1rem;\n}\n\n.c-pwa-promo {\n  position: fixed;\n  bottom: 1.875rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10; // should be less than modal, tooltip, prompt etc.\n  text-align: left;\n  width: calc(100vw - 3rem);\n  max-width: 31.25rem;\n\n  ::v-deep .c-body {\n    margin-top: 1rem;\n    text-align: right;\n  }\n}\n\n.c-install-btn {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__